import { CloseIcon } from 'assets/icons/CloseIcon'
import { DropZone } from 'components/DropZone/DropZone'
import { Modal } from 'components/Modal/Modal'
import { endOfWeek, startOfDay } from 'date-fns'
import { getAttendances, importAttendances } from 'features/attendance/attendanceSlice'
import { setConfirmModal } from 'features/global/globalSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { convertToDate, getUtcMonthRange } from 'utils/helpers'

export const AttendanceImportModal = ({ closeModal, active, params }: { closeModal: any, active: string, params: any }) => {
    const dispatch = useDispatch<AppDispatch>()
    useModalClose(closeModal)
    const [file, setFile] = useState<File>(null)

    const handleSave = async () => {
        const resp = await dispatch(importAttendances({ file, should: false }))

        if (resp.payload.message == 'There are some attendances that are not related to any shift. Do you want to import anyway?.') {
            closeModal()
            dispatch(
                setConfirmModal({
                    isOpen: true,
                    onSave: async () => {
                        const reps2 = await dispatch(importAttendances({ file, should: true }))
                        if (reps2.meta.requestStatus === 'fulfilled') {
                            toast.success('Attendance imported successfully')
                        } else {
                            return
                        }
                        await dispatch(getAttendances(active == 'weekly' ? {
                            ...params, dateFrom: convertToDate(startOfDay(new Date())),
                            dateTo: convertToDate(endOfWeek(new Date())),
                            page: 1
                        } : { ...params, page: 1, ...getUtcMonthRange(new Date().getMonth()) }))
                    },
                    sentence: 'There are some attendances that are not related to any shift. Do you want to import anyway?',
                }),

            )
        } else {
            await dispatch(getAttendances(active == 'weekly' ? {
                ...params, dateFrom: convertToDate(startOfDay(new Date())),
                dateTo: convertToDate(endOfWeek(new Date())),
                page: 1
            } : { ...params, page: 1, ...getUtcMonthRange(new Date().getMonth()) }))
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center >
            <Flex mb='16' column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' > Import Attendance</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex width='100%' justcenter column center gap='1rem' >
                    <BodyText style={{ marginTop: 30 }} >Import from file</BodyText>
                    <DropZone file={file} setFile={setFile} />
                </Flex>
            </Flex>
            <Button disabled={!file} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IMealTypeModal {
    id?: number
    type: string
}